import { Icon } from 'components/Icon'
import { IconName } from 'components/Icon/iconNames'
import { Text } from 'components/Text'
import { ComponentProps, useState } from 'react'
import { CollapsibleMenuRoot, Content, MenuTrigger, Wrapper } from './CollapsibleMenu.styles'

type MenuOwnProps = ComponentProps<typeof CollapsibleMenuRoot>

export type CollapsibleMenuProps = MenuOwnProps & {
  label: string
  interactiveElement?: JSX.Element
  hasMaxWidth?: boolean
  labelColor?: any
}

export const CollapsibleMenu = ({
  label,
  interactiveElement,
  children,
  hasMaxWidth = true,
  labelColor = 'primary-800',
  ...rest
}: CollapsibleMenuProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const iconName: IconName = isOpen ? 'arrow-up-line' : 'arrow-down-line'

  return (
    <CollapsibleMenuRoot onOpenChange={() => setIsOpen(!isOpen)} defaultOpen={false} {...rest}>
      <Wrapper css={{ paddingLeft: interactiveElement ? '$3' : 0 }}>
        {interactiveElement}
        <MenuTrigger
          aria-label={label}
          css={{ justifyContent: interactiveElement ? 'flex-end' : 'space-between' }}
        >
          {!interactiveElement && (
            <Text size="headline" weight="medium" color={labelColor} align="left">
              {label}
            </Text>
          )}
          <Icon name={iconName} />
        </MenuTrigger>
      </Wrapper>
      <Content hasMaxWidth={hasMaxWidth}>{children}</Content>
    </CollapsibleMenuRoot>
  )
}

CollapsibleMenu.displayName = 'CollapsibleMenu'
